import { Leaf, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const LinkExpired = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    // Navigate to root, but the root will show onboarding since there's no session
    // This is the expected behavior - user can register or login from there
    navigate('/', { replace: true });
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <div className="text-center space-y-6 max-w-md">
        {/* Icon */}
        <div className="flex justify-center">
          <div className="p-4 bg-destructive/10 rounded-full">
            <Leaf className="w-12 h-12 text-destructive" />
          </div>
        </div>

        {/* Title */}
        <h1 className="font-bold text-3xl text-foreground">
          Link Expired 🔗
        </h1>

        {/* Description */}
        <p className="text-muted-foreground text-lg">
          The magic link has expired. Please go back to the app and log in to get a new link.
        </p>

        {/* Funny Quote */}
        <blockquote className="border-l-4 border-primary pl-4 italic text-muted-foreground bg-muted/30 p-4 rounded-r-lg">
          "Your login attempt fell off the Elliptic Curve. The nonce has expired, and the signature is no longer valid. Let's generate a new point on the curve for you."
        </blockquote>

        {/* Home Button */}
        <Button
          onClick={handleGoHome}
          className="w-full h-14 text-lg rounded-xl bg-primary hover:bg-primary/90"
        >
          Home
          <ArrowRight className="w-5 h-5 ml-2" />
        </Button>
      </div>
    </div>
  );
};

export default LinkExpired;

